import { render, staticRenderFns } from "./article_position_content.vue?vue&type=template&id=444d975b&"
import script from "./article_position_content.vue?vue&type=script&lang=js&"
export * from "./article_position_content.vue?vue&type=script&lang=js&"
import style0 from "./article_position_content.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports